import React from 'react';
import Translate from 'react-translate-component';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { path } from 'ramda';

import { openModalSotrMeetCreate, openModalTaskCreate } from 'actions/modalActions';
import CustomIcon from 'components/common/CustomIcon';
import CalendarUserFilter from './CalendarUserFilter';

const mapDispatchToProps = {
    openModalSotrMeetCreate,
    openModalTaskCreate
};

function CalendarControls({ userId, openModalSotrMeetCreate, openModalTaskCreate, user: { id: currentUserId, permissions }, date }) {
    const isNotOwnCalendar = parseInt(userId, 10) !== currentUserId;

    return (
        <div className="calendar-controls">
            <Button icon={<CustomIcon type='calendar-plus' />} onClick={() => openModalSotrMeetCreate({ date })} disabled={isNotOwnCalendar}>
                <Translate content='worksheet.create'/>
            </Button>
            <Button icon={<CustomIcon type='note-plus' />} onClick={() => openModalTaskCreate({ date })} disabled={isNotOwnCalendar}>
                <Translate content='calendar.create.task'/>
            </Button>
            <CalendarUserFilter userId={userId} disabled={!path(['web', 'userFilter'], permissions)} />
        </div>
    );
}

export default connect(null, mapDispatchToProps)(CalendarControls);
